import React from 'react';
import { Section, FadeIn } from './ui';
export const ChaptersSection = () => {
  const chapters = [{
    num: 1,
    desc: 'Entenderás exactamente CÓMO llegaste aquí — sin juzgarte, sin culparte — y por qué no es tu culpa'
  }, {
    num: 2,
    desc: 'Descubrirás el peso invisible que nadie ve y que te está robando la energía en silencio'
  }, {
    num: 3,
    desc: 'Reconocerás el momento exacto en que te perdiste a ti misma — y encontrarás el camino de regreso —'
  }, {
    num: 4,
    desc: 'Entenderás la trampa de la culpa y cómo salir de ella sin dejar de amar'
  }, {
    num: 5,
    desc: 'Aprenderás a decir NO sin sentirte mala persona — con palabras exactas que puedes usar hoy —'
  }, {
    num: 6,
    desc: 'Recuperarás tu espacio, tu voz y tu derecho a existir para ti misma'
  }, {
    num: 7,
    desc: 'Aprenderás el autocuidado REAL — no el de las revistas — el que funciona en tu vida cotidiana'
  }, {
    num: 8,
    desc: 'Construirás la nueva versión de ti con un plan concreto de 90 días'
  }];
  return <Section className="bg-cream-100" data-id="element-46">
      <FadeIn data-id="element-47">
        <div className="text-center mb-8 sm:mb-16" data-id="element-48">
          <h2 className="text-2xl sm:text-4xl font-serif text-navy-900 mb-2 sm:mb-4" data-id="element-49">
            Lo Que Encuentras Dentro
          </h2>
          <p className="text-xl text-gray-600" data-id="element-50">
            Todo lo que este libro hace por ti:
          </p>
        </div>

        <div className="space-y-3 sm:space-y-4" data-id="element-51">
          {chapters.map((chapter, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-52">
              <div className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-8 shadow-sm border border-cream-200 flex flex-col sm:flex-row gap-3 sm:gap-6 items-start sm:items-center" data-id="element-53">
                <div className="bg-rose-50 text-rose-600 font-serif text-base sm:text-xl font-medium px-3 py-1 sm:px-4 sm:py-2 rounded-lg shrink-0" data-id="element-54">
                  CAPÍTULO {chapter.num}
                </div>
                <p className="text-base sm:text-lg text-gray-700 leading-relaxed" data-id="element-55">
                  {chapter.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </FadeIn>
    </Section>;
};